export const stripHtmlTags = (value: string): string => {
  if (!value) return ''

  // Convert the value to a string
  value = value.toString()

  // Remove HTML tags using a regular expression
  return value.replace(/<\/?[^>]+(>|$)/g, '')
}
